import ODataResponse from "../data/entities/ODataResponse";
import TubingModel from "../data/entities/TubingModel";
import TubingRepo from "../data/repo/TubingRepo";

export class TubingService {
  async getAllTubings(oDataQuery: string = ""): Promise<ODataResponse<TubingModel>> {
    const response = await new TubingRepo().getTubings(oDataQuery);
    return response;
  }

  async getTubingDetails(id: string): Promise<TubingModel> {
    const response = await new TubingRepo().getDetails(id);
    return response;
  }

  async updateTubingDetails(id: string, data: TubingModel): Promise<boolean | undefined> {
    return await new TubingRepo().updateDetails(id, data);
  }

  async addTubing(data: TubingModel): Promise<boolean | undefined> {
    return await new TubingRepo().addTubing(data);
  }

  async deleteTubing(id: number): Promise<boolean> {
    const deleted = await new TubingRepo().delete(id);
    return deleted;
  }

  async getTubingsList(companyId?: number): Promise<TubingModel[]> {
    const filter = companyId != null ? `$filter=CompanyId eq ${companyId}&` : "";
    const oDataQuery = await this.getAllTubings(`${filter}expand=Company`);
    if (!oDataQuery) return [];
    const count = oDataQuery["@odata.count"] ?? 0;
    return count > 0 ? oDataQuery.value : [];
  }

  async getTubingFlwBaseline(id: number) {
    return await new TubingRepo().getTubingFlwBaseline(id);
  }

  async addTubingBaselinePoint(id: number, position: number, wallThickness: number) {
    return await new TubingRepo().addTubingBaselinePoint(id, position, wallThickness);
  }

  async updateTubingBaselinePoint(id: number, cpId: number, position: number, wallThickness: number) {
    return await new TubingRepo().updateTubingBaselinePoint(id, cpId, position, wallThickness);
  }

  async deleteTubingBaselinePoint(id: number, cpId: number) {
    return await new TubingRepo().deleteTubingBaselinePoint(id, cpId);
  }

  async getFlwBaselineChart(id: number) {
    return await new TubingRepo().getFlwBaselineChart(id);
  }

  async uploadMillCert(id: number, file: File) {
    return await new TubingRepo().uploadMillCert(id, file);
  }

  async downloadMillCert(id: number): Promise<Blob | null> {
    return await new TubingRepo().downloadMillCert(id);
  }

  async deleteMillCert(id: number) {
    return await new TubingRepo().deleteMillCert(id);
  }
}

export default TubingService;
